import { eventMomentFactory } from '../../../../../../data/misc/eventMomentFactory';
import { useMemo } from 'react';
import { sortBy, uniq } from 'lodash';
import { DATE_ISO_FORMAT } from '../../../../../../data/constants/datetime';

export function useMeetingsGroupedByDate(event, meetings) {
    return useMemo(() => {
        const dates = uniq(meetings.map((m) => eventMomentFactory(event, m.start_local).format(DATE_ISO_FORMAT)).sort());

        return dates.map((d) => {
            return {
                date: d,
                meetings: sortBy(
                    meetings.filter((m) => eventMomentFactory(event, m.start_local).format(DATE_ISO_FORMAT) === d),
                    'start_local'
                ),
            };
        });
    }, [event, meetings]);
}
